import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TextField } from '~common/components/form/field-text.component';
import {
  TranslationField,
  TranslationFormData,
} from '~admin/view/components/ui/form/fields/field-translation.component';
import { Box } from '~common/components/box.component';
import { Color } from '~common/model/basics';
import { DeleteIcon } from '~web/view/components/ui/icon/delete.icon';

interface Props {
  name: string;
  index: number;
  onRemove?: (index: number) => void;
}

export interface EventTimelineItemFormData {
  title: TranslationFormData<string>[];
  description: TranslationFormData<string>[];
  rank: number;
}

export const EventTimelineItemFields: React.FunctionComponent<Props> = ({
  name,
  index,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <RestrictBox>
        <TranslationField
          name={`${name}.title`}
          label={t('createEvent.eventDetails.timeline.timelineGroup.timelineGroupItem.title')}
          render={(renderProps): ReactNode => <TextField {...renderProps} />}
        />
      </RestrictBox>
      <RestrictBox>
        <TranslationField
          name={`${name}.description`}
          label={t('createEvent.eventDetails.timeline.timelineGroup.timelineGroupItem.description')}
          render={(renderProps): ReactNode => <TextField {...renderProps} />}
        />
      </RestrictBox>
      <IconBox>
        <DeleteIcon
          color={Color.White}
          onClick={(): void => {
            onRemove?.(index);
          }}
        />
      </IconBox>
    </Container>
  );
};

const Container = styled(Box)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin: 0 12px;
`;

const IconBox = styled(Box)`
  flex: 0.1 0.1 auto;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-timeline-details/event-timeline-item-fields.component.tsx